/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Channel_DefaultInputs */

const en_us2_push_channel_default = /** @type {(inputs: Push_Channel_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Pocket Gym`)
};

const pt_br2_push_channel_default = /** @type {(inputs: Push_Channel_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Pocket Gym`)
};

const es_419_push_channel_default = /** @type {(inputs: Push_Channel_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Pocket Gym`)
};

const pt_pt2_push_channel_default = /** @type {(inputs: Push_Channel_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Pocket Gym`)
};

const fr_fr2_push_channel_default = /** @type {(inputs: Push_Channel_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Pocket Gym`)
};

const de_de2_push_channel_default = /** @type {(inputs: Push_Channel_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Pocket Gym`)
};

const it_it2_push_channel_default = /** @type {(inputs: Push_Channel_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Pocket Gym`)
};

/**
* | output |
* | --- |
* | "My Pocket Gym" |
*
* @param {Push_Channel_DefaultInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_channel_default = /** @type {((inputs?: Push_Channel_DefaultInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Channel_DefaultInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_channel_default(inputs)
	if (locale === "es-419") return es_419_push_channel_default(inputs)
	if (locale === "pt-PT") return pt_pt2_push_channel_default(inputs)
	if (locale === "fr-FR") return fr_fr2_push_channel_default(inputs)
	if (locale === "de-DE") return de_de2_push_channel_default(inputs)
	if (locale === "it-IT") return it_it2_push_channel_default(inputs)
	return en_us2_push_channel_default(inputs)
});
export { push_channel_default as "push.channel_default" }